<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cLlCGH/tc-custom/9781250086532.jpg?1732052122693" alt="This image is the cover for the book Elizabeth and After"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Elizabeth and After
      </h1>
      <p class="bookDescription body article font2">
        <p>A touching and resonant story of a man who returns to the small town of West Gull, Ontario, to mend his family's legacy of alcohol and violence, to reconnect with his young daughter, and to reconcile himself with the spirit of his beautiful mother, killed several years earlier in a tragic accident. <i>Elizabeth and After</i> masterfully wraps us up in the lives of Carl and his family, and the other 683 odd residents of this snowy Canadian hamlet.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matt Cohen
      </h2>
      
      <p class="authorDescription body article"><B>Matt Cohen </B>is the author of 13 novels.  His books have been published in over 9 countries, and have been finalists for both the Trillium Award and the Governor General's Award for Fiction.  He lives in Toronto, Ontario.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Picador
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78e1c5fe